// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__26fmF","list":"PatternAutocomplete_list__2lks2"};